import React, { useEffect, useState } from "react";
import { api } from "../../app/Api/ApiSlice";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const EmailVerify = () => {
  const [loading, setLoading] = useState(false);
  const [cooldown, setCooldown] = useState(0);
  const [status, setStatus] = useState("idle");

  const navigate = useNavigate();

  const params = new URLSearchParams(window.location.search);
  const token = params.get("token");
  const email = params.get("email");

  useEffect(() => {
    if (!token) return;

    console.log(token)

    const verifyEmail = async () => {
      setStatus("verifying");

      try {
        await api.post("/account/verify-email", { token });
        setStatus("success");
        toast.success("Email verified successfully");

        setTimeout(() => {
          navigate("/login");
        }, 2000);
      } catch (err) {
        setStatus("error");
        toast.error(err.response?.data?.message || "Verification failed");
      }
    };

    verifyEmail();
  }, [token, navigate]);

  const resendEmail = async () => {
    if (cooldown > 0 || loading || !email) return;

    setLoading(true);

    try {
      await api.post("/account/resend-verification", { email });
      toast.success("Verification link sent");

      setCooldown(60);

      const interval = setInterval(() => {
        setCooldown((prev) => {
          if (prev <= 1) {
            clearInterval(interval);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to resend email");
    } finally {
      setLoading(false);
    }
  };

  // Shared container
  const containerStyle = {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#f7f7f7",
    padding: "20px",
  };

  const cardStyle = {
    width: "100%",
    maxWidth: "420px",
    background: "#fff",
    padding: "30px",
    borderRadius: "12px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
    textAlign: "center",
  };

  const buttonStyle = {
    width: "100%",
    marginTop: "20px",
    padding: "12px",
    borderRadius: "8px",
    border: "none",
    fontWeight: "600",
    fontSize: "14px",
    cursor: "pointer",
    transition: "0.2s ease",
  };

  // VERIFY FLOW UI
  if (token) {
    return (
      <div style={containerStyle}>
        <div style={cardStyle}>
          <h2 style={{ marginBottom: "10px" }}>Email Verification</h2>

          {status === "verifying" && (
            <>
              <div style={{ fontSize: "40px" }}>⏳</div>
              <p style={{ marginTop: "10px", color: "#555" }}>
                Verifying your email...
              </p>
            </>
          )}

          {status === "success" && (
            <>
              <div style={{ fontSize: "40px", color: "green" }}>✔</div>
              <p style={{ marginTop: "10px", color: "#333" }}>
                Email verified successfully
              </p>
              <p style={{ fontSize: "13px", color: "#777" }}>
                Redirecting to login...
              </p>
            </>
          )}

          {status === "error" && (
            <>
              <div style={{ fontSize: "40px", color: "red" }}>✖</div>
              <p style={{ marginTop: "10px", color: "#333" }}>
                Verification failed
              </p>
              <p style={{ fontSize: "13px", color: "#777" }}>
                The link may be invalid or expired
              </p>
            </>
          )}
        </div>
      </div>
    );
  }

  // RESEND FLOW UI
  return (
    <div style={containerStyle}>
      <div style={cardStyle}>
        <h2 style={{ marginBottom: "10px" }}>Verify your email</h2>

        <p style={{ fontSize: "14px", color: "#555" }}>
          We sent a verification link to your email address.
        </p>

        <p style={{ fontSize: "13px", color: "#888", marginTop: "10px" }}>
          Didn’t receive it? Check spam or resend below.
        </p>

        <button
          onClick={resendEmail}
          disabled={loading || cooldown > 0 || !email}
          style={{
            ...buttonStyle,
            backgroundColor: cooldown > 0 ? "#ccc" : "#e63946",
            color: "#fff",
          }}
        >
          {loading
            ? "Sending..."
            : cooldown > 0
            ? `Resend in ${cooldown}s`
            : "Resend verification email"}
        </button>
      </div>
    </div>
  );
};

export default EmailVerify;